<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>
          <v-row>
            <v-col
                cols="12"
                sm="3">
              <v-chip small label color="primary">ارسال پیام</v-chip>
            </v-col>
            <v-spacer/>
            <v-col
                cols="12"
                sm="3">
              <label><span style="color: #000000;"> تاریخ:</span><span> {{ date }}</span></label>
            </v-col>

          </v-row>

        </v-card-subtitle>
        <v-spacer/>
        <v-card-text>
           <PreviewPage :model="localModel" :cost="cost" :credit-balance="creditBalance"
             :date="date" :preview-text="previewText" :dialog-status.sync="localDialogStatus"/>

          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col
                  cols="12"
                  sm="3">
                <label><span style="color: #000000;">مجتمع:</span><span> {{ buildingName }}</span></label>
              </v-col>

              <v-col cols="12" sm="4">
                <v-autocomplete
                    :items="templateItems"
                    dense
                    item-text="templateFa"
                    item-value="id"
                    v-model="templateId"
                    outlined
                    @change="onTemplateChanged"
                    auto-select-first append-icon="fas fa-angle-down"
                    label="انتخاب قالب"

                />
              </v-col>

              <v-col cols="12" sm="4">
                <v-autocomplete
                    :items="userItems"
                    v-model="usersSelect"
                    outlined
                    dense
                    return-object
                    label="انتخاب اشخاص"
                    multiple
                >
                  <template v-slot:prepend-item>
                    <v-checkbox
                        :indeterminate="selectedUsers.length > 0 && selectedUsers.length < userItems.length"
                        v-model="selectAll"
                        label="انتخاب همه"
                    />
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0">{{ item.text }}</span>
                    <span v-if="index === 1" class="grey--text caption">
      (+{{ usersSelect.length - 1 }} دیگر)
    </span>
                  </template>
                </v-autocomplete>


              </v-col>

              <v-col
                  cols="12"
                  sm="12"
              >
                <!-- ۳. بخش پیش‌نمایش (Preview) -->
                <v-card class="pa-2" id="style-1" style="overflow: auto;height: 150px" color="grey lighten-4">
                  <v-subheader>پیش‌نمایش</v-subheader>
                  <div class="pa-2 border-dashed">
                    {{ previewText || 'متن پیش‌نمایش در اینجا ظاهر می‌شود...' }}
                  </div>
                </v-card>
              </v-col>

            </v-row>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="primary"
                  class=" pr-1 pl-1"
                  @click="sendSms"
                  :loading="loading"
              >
                ثبت و ارسال
              </v-btn>
              <v-btn
                  small
                  depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import PreviewPage from "@/views/reporting/remainingReport/PreviewPage.vue";


export default {
  components:{
    PreviewPage
  },
  props: {
    dialogStatus: {
      default: false,
    },
    buildingName: String,
    buildingId: String,
    templateItems: Array,
    dataList: Array,
    model: Object,
    userItems: Array,
    date: String,
    creditBalance: Number,
    cost: Number,
  },
  data() {
    return {
      placeholders: [],
      mapping: {},
      count: 1,
      message: "",
      templateId: "",
      loading: false,
      selectAll: false,
      localDialogStatus: false,
      selectedUsers: [],
      localModel: JSON.parse(JSON.stringify(this.model))
    }
  },

  watch: {
    selectAll(val) {
      if (val) {
        this.selectedUsers = [...this.userItems]
      } else {
        if (this.selectedUsers.length === this.userItems.length) {
          this.selectedUsers = []
        }
      }
    },
    model: {
      handler(newVal) {
        this.localModel = JSON.parse(JSON.stringify(newVal))
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    usersSelect: {
      get() {
        return this.selectedUsers
      },
      set(val) {
        this.selectedUsers = val || []

        // منطقِ دقیق برای تشخیصِ وضعیتِ "انتخاب همه"
        if (this.userItems.length > 0) {
          this.selectAll = this.selectedUsers.length === this.userItems.length
        } else {
          this.selectAll = false
        }
      }
    },
    // متن نهایی با جایگزینی مقادیر
    previewText() {
      let text = this.message;
      for (const [ph, field] of Object.entries(this.mapping)) {
        if (field && this.dataList[field]) {
          text = text.split(ph).join(this.dataList[field]);
        }
      }
      return text;
    }
  },
  methods: {
    closed() {
      this.$root.$emit("reset_all_dialogs_sms");
      this.loading = false
      this.$emit('update:dialogStatus', false)
    },
    // استخراج متغیرها و به‌روزرسانی لیست نگاشت
    onTemplateChanged(id) {
      this.message = this.templateItems.filter(t => t.id === id)[0].message
    },

    sendSms() {
      if(!this.templateId){
        this.$snack({type: 'error', message: 'قالب پیام انتخاب نشده است!'});
        return
      }
      if(this.usersSelect.length===0){
        this.$snack({type: 'error', message: 'کاربری انتخاب نشده است!'});
        return
      }
      this.localModel.dataList.push(...this.dataList);
      this.localModel.buildingId = this.buildingId
      this.localModel.templateId = this.templateId
      this.localModel.date = this.date
      this.localModel.receiverItem.push(...this.usersSelect)
      this.localDialogStatus = true

    },
    reset(){
      this.localModel= JSON.parse(JSON.stringify(this.model))
    }

  },
  mounted() {
    this.$root.$on('resetDialogsPreviewSms', () => {
      this.reset()
    })
  }

}
</script>


